interface SellerUserCardProps {
  storeName: string;
  ownerName: string;
  email: string;
  phone: string;
  joinDate: string;
}

export function SellerUserCard({ 
  storeName, 
  ownerName, 
  email, 
  phone, 
  joinDate 
}: SellerUserCardProps) {
  // Format date to YYYY-MM-DD
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="mx-4 p-3 border-[1.5px] border-[#86DB89] rounded-xl">
      <div className="mb-3">
        <h2 className="text-[20px] font-semibold text-[#222222]">{storeName}</h2>
      </div>
      
      <div className="flex items-center gap-4 mb-2">
        <span className="text-[16px] font-medium text-[#222222]">{ownerName}</span>
        <span className="text-[16px] font-medium text-[#222222]">{email}</span>
      </div>
      
      <div className="text-[16px] font-medium text-[#222222] mb-2">
        {phone}
      </div>
      
      <div className="flex items-center gap-1">
        <span className="text-[16px] font-medium text-[#222222]">가입일:</span>
        <span className="text-[16px] font-medium text-[#222222]">{formatDate(joinDate)}</span>
      </div>
    </div>
  );
}